/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll virtual dice online. Choose how many dice and how many sides, then roll to see each result and the total — perfect for board games and tabletop RPGs.`)
};

const es_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tira dados virtuales online. Elige cuántos dados y cuántas caras, y luego lanza para ver cada resultado y el total — perfecto para juegos de mesa y juegos de rol.`)
};

const de_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Würfle virtuelle Würfel online. Wähle die Anzahl der Würfel und die Seitenzahl, dann würfle, um jedes Ergebnis und die Summe zu sehen — perfekt für Brettspiele und Pen-&-Paper-Rollenspiele.`)
};

const nl_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gooi online met virtuele dobbelstenen. Kies hoeveel dobbelstenen en hoeveel zijden, en gooi om elk resultaat en het totaal te zien — perfect voor bordspellen en tabletop RPG's.`)
};

const fr_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez des dés virtuels en ligne. Choisissez le nombre de dés et de faces, puis lancez pour voir chaque résultat et le total — parfait pour les jeux de société et les jeux de rôle sur table.`)
};

const it_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancia dadi virtuali online. Scegli quanti dadi e quante facce, poi lancia per vedere ogni risultato e il totale — perfetto per giochi da tavolo e giochi di ruolo.`)
};

const pt_br2_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role dados virtuais online. Escolha quantos dados e quantos lados cada um tem, depois role para ver cada resultado e o total — perfeito para jogos de tabuleiro e RPGs de mesa.`)
};

const pt_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance dados virtuais online. Escolha quantos dados e quantas faces, depois lance para ver cada resultado e o total — perfeito para jogos de tabuleiro e RPGs de mesa.`)
};

const ja_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインで仮想サイコロを振れます。サイコロの個数と面数を選んで振ると、各結果と合計が表示されます — ボードゲームやテーブルトークRPGに最適です。`)
};

const zh_dice_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线掷虚拟骰子。选择骰子数量和面数，点击掷骰查看每个结果及总和——非常适合桌游和桌面角色扮演游戏。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_intro", locale)
	if (locale === "en") return en_dice_intro(inputs)
	if (locale === "es") return es_dice_intro(inputs)
	if (locale === "de") return de_dice_intro(inputs)
	if (locale === "nl") return nl_dice_intro(inputs)
	if (locale === "fr") return fr_dice_intro(inputs)
	if (locale === "it") return it_dice_intro(inputs)
	if (locale === "pt-BR") return pt_br2_dice_intro(inputs)
	if (locale === "pt") return pt_dice_intro(inputs)
	if (locale === "ja") return ja_dice_intro(inputs)
	return zh_dice_intro(inputs)
};